
import TranResourcesApi from './src/Tranresources'
import CarParkRecordApi from './src/CarParkRecordApi'
import CarParkFeeApi from './src/CarParkFeeApi'

let apis = {
   TranResourcesApi,
   CarParkRecordApi,
   CarParkFeeApi
};

export default apis;
